package ru.chm.gradereport.ui.screens.course

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import ru.chm.gradereport.model.HomeworkDto
import ru.chm.gradereport.model.HomeworkScoreItem
import ru.chm.gradereport.model.LessonSessionDto
import ru.chm.gradereport.model.StudentStatsDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.MutedText
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.components.SectionTitle
import ru.chm.gradereport.ui.screens.course.sheet.HomeworkDetailsDialog

@Composable
fun StudentStatsDialog(
    stats: StudentStatsDto,
    isAdmin: Boolean = false,
    showSubmissionLinks: Boolean = false,
    publicToken: String = "",
    onClose: () -> Unit,
) {
    var viewingHomework by remember { mutableStateOf<HomeworkScoreItem?>(null) }

    Dialog(
        onDismissRequest = onClose,
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        AppCard(
            modifier = Modifier
                .widthIn(min = 520.dp, max = 760.dp)
                .fillMaxWidth(0.92f)
                .heightIn(max = 720.dp),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Column(modifier = Modifier.weight(1f).padding(end = 12.dp)) {
                    SectionTitle(stats.student.fullName)
                    MutedText(stats.courseName, modifier = Modifier.padding(top = 4.dp))
                    if (stats.student.uid.isNotBlank()) {
                        MutedText("UID ${stats.student.uid}", modifier = Modifier.padding(top = 2.dp))
                    }
                }
                SecondaryButton(text = "Закрыть", onClick = onClose)
            }

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .heightIn(max = 560.dp)
                    .verticalScroll(rememberScrollState())
                    .padding(top = 8.dp),
            ) {
                StudentStatsContent(
                    stats = stats,
                    showSubmissionLinks = showSubmissionLinks,
                    onOpenHomework = { viewingHomework = it },
                )
            }
        }
    }

    viewingHomework?.let { item ->
        val session = item.toSessionOrNull(stats.student.courseId)
        HomeworkDetailsDialog(
            homework = item.toHomeworkDto(stats.student.courseId),
            sessions = listOfNotNull(session),
            session = session,
            editable = false,
            isAdmin = isAdmin,
            publicToken = publicToken,
            onDismiss = { viewingHomework = null },
            onSave = { _, _, _, _ -> },
            onDelete = {},
        )
    }
}

internal fun HomeworkScoreItem.toHomeworkDto(courseId: String) = HomeworkDto(
    id = homeworkId,
    courseId = courseId,
    sessionId = null,
    title = title,
    description = description,
    maxScore = maxScore,
    orderIndex = 0,
)

internal fun HomeworkScoreItem.toSessionOrNull(courseId: String): LessonSessionDto? {
    if (sessionDate.isBlank() && sessionTitle.isBlank()) return null
    return LessonSessionDto(
        id = "",
        courseId = courseId,
        date = sessionDate,
        title = sessionTitle,
    )
}
